import React from 'react';

const SettingsHeader = ({ id, children }) => {
  return (
    <h2
      className="text-base font-semibold text-gray-900 dark:text-foreground flex items-start"
      id={id}
    >
      {children}
    </h2>
  );
};

export default SettingsHeader;
